import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./LockHintDialog.css";

// Shown when a user clicks a locked field in the Job Booking modal.
// The unlock path always lives on Job Details, so the only actions are
// acknowledge ("Got it") or navigate there WITHOUT saving.
const VARIANTS = {
  contract: {
    title: "Revoke contract to unlock field",
    body: "Revoke the contract from Job Details to unlock this field.",
  },
  payment: {
    title: "Cancel payment link to unlock field",
    body: "Cancel the payment link from Job Details to unlock this field.",
  },
  both: {
    title: "Unlock requires two steps",
    body: "Void the contract and cancel the payment link from Job Details to unlock this field.",
  },
};

const LockHintDialog = ({
  show,
  variant = "contract",
  onClose,
  onGoToDetail,
}) => {
  const copy = VARIANTS[variant] || VARIANTS.contract;

  return (
    <Modal show={show} onHide={onClose} centered className="lock-hint-dialog">
      <Modal.Header closeButton>
        <Modal.Title>{copy.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{copy.body}</Modal.Body>
      <Modal.Footer>
        {onGoToDetail && (
          <Button variant="outline-primary" onClick={onGoToDetail}>
            Go to Job Details
          </Button>
        )}
        <Button variant="primary" onClick={onClose}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LockHintDialog;
